<template>
  <div>
    <span class="role-table" v-if="client">
      {{ label }}
    </span>
    <a
      v-if="client"
      class="text-capitalize hide-data"
      :href="href"
      target="_blank"
    >
      {{ name }}
    </a>
    <span v-else class="text-danger text-capitalize">Unassigned</span>
  </div>
</template>

<script>
/**
 * Presentational badge for a client (agent/customer): role label + link to
 * their record, or an "Unassigned" placeholder when there's no client.
 * Used by ShowAgent and ShowCustomer, which supply the formatted label/href/name.
 */
export default {
  name: "ClientBadge",
  props: {
    /**
     * The client record; null renders the "Unassigned" placeholder.
     * @type {Object|null}
     */
    client: {
      type: Object,
      default: null
    },
    /**
     * Formatted role label (e.g. "Agent", "Travel Agency").
     * @type {String}
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Link target for the client's record.
     * @type {String}
     */
    href: {
      type: String,
      default: ""
    },
    /**
     * Display name shown in the link.
     * @type {String}
     */
    name: {
      type: String,
      default: "Unassigned"
    }
  }
};
</script>
